// wizardSteps/IntroductionStep.js
const IntroductionStep = () => {
    return (
      <div>
        <h2>Welcome to the Asset Creation Wizard</h2>
        <p>This wizard will guide you through the process of creating a new asset.</p>
      </div>
    );
  };
  export default IntroductionStep;